<div class="accordion" [ngClass]="hostClasses">
  <button type="button" class="accordion-header" (click)="toggleAccordion($event, id)">
    <div class="accordion-header-container">
      @if (innerIcon) {
        {{ innerIcon }}
      }
      <span *ngIf="icon" class="material-symbols-outlined">{{ icon }}</span>
      <ng-content select="[accordionTitle]">
        <div class="accordion-title" [innerHTML]="title"></div>
      </ng-content>
    </div>

    @if (iconStyle === 'arrow') {
      @if (isActive) {
        <span class="material-symbols-outlined">expand_less</span>
      } @else {
        <span class="material-symbols-outlined">expand_more</span>
      }
    }

    @if (iconStyle === 'symbol') {
      @if (isActive) {
        <span class="material-symbols-outlined">remove</span>
      } @else {
        <span class="material-symbols-outlined">add</span>
      }
    }
  </button>

  <div class="accordion-container" [style]="'display:' + (isActive ? 'block' : 'none')">
    <ng-content></ng-content>
  </div>
</div>
